export const getPath = (pathname = '') => pathname.replace(/^\//, '').split('/').pop();
